import { FUND_TYPES } from '../../constants/constants';
import CaresContainer from './fundtypes/cares/CaresContainer';
import LiheapSection from './fundtypes/liheap/LiheapSection';
import OtherFundSection from './fundtypes/other/OtherFundSection';
import WinterHelpSection from './fundtypes/winterhelp/WinterHelpSection';
import PpcSection from './fundtypes/ppc/PpcSection';

const FundTypeRenderer = ({
  form,
  formData,
  setFormField,
  onCaresTypeChange,
  isSubmitting,
}) => {

  switch (form?.fundType) {
    case FUND_TYPES.CARES:
      return (
        <CaresContainer
          form={form}
          formData={formData}
          setFormField={setFormField}
          onCaresTypeChange={onCaresTypeChange}
          isSubmitting={isSubmitting}
        />
      );
    case FUND_TYPES.LIHEAP:
      return (
        <LiheapSection
          state={formData?.state}
          currentEnergyDiscount={formData?.currentDiscountPercentage}
          householdSize={form.householdSize}
          onHouseholdSizeChange={value => setFormField('householdSize', value)}
          income={form.income}
          onIncomeChange={value => setFormField('income', value)}
          energyDiscount={form?.energyDiscount}
          incomeMeasurementType={form?.incomeMeasurementType}
          incomeMeasurementPercentage={form?.incomeMeasurementPercentage}
          arrearage={form?.arrearage}
          pledgeAmount={form?.pledgeAmount}
          onPledgeAmountChange={value => setFormField('pledgeAmount', value)}
          additionalInformation={form.additionalInformation}
          onAdditionalInformationChange={value => setFormField('additionalInformation', value)}
          isSubmitting={isSubmitting}
        />
      );
    case FUND_TYPES.PPC:
      return (
        <PpcSection
          state={formData?.state}
          incomeMeasurementType={form.incomeMeasurementType}
          onIncomeMeasurementTypeChange={value => setFormField('incomeMeasurementType', value)}
          incomeMeasurementPercentage={form.incomeMeasurementPercentage}
          onIncomeMeasurementPercentageChange={value => setFormField('incomeMeasurementPercentage', value)}
          energyDiscount={form.energyDiscount}
          arrearage={form.arrearage}
          pledgeAmount={form.pledgeAmount}
          onPledgeAmountChange={value => setFormField('pledgeAmount', value)}
          submissionType={form.submissionType}
          onSubmissionTypeChange={value => setFormField('submissionType', value)}
          additionalInformation={form.additionalInformation}
          onAdditionalInformationChange={value => setFormField('additionalInformation', value)}
          isSubmitting={isSubmitting}
        />
      );
    case FUND_TYPES.WINTERHELP:
      return (
        <WinterHelpSection
          pledgeAmount={form?.pledgeAmount}
          onPledgeAmountChange={value => setFormField('pledgeAmount', value)}
          additionalInformation={form?.additionalInformation}
          onAdditionalInformationChange={value => setFormField('additionalInformation', value)}
          setFundType={value => setFormField('fundType', value)}
          state={formData?.state}
          winterHelpPledges={formData?.pledgesAppliedWithCurrentProgramYear?.[FUND_TYPES.WINTERHELP]}
          isSubmitting={isSubmitting}
      />)
    case FUND_TYPES.OTHER:
      return (
        <OtherFundSection
          state={formData?.state}
          otherFundType={form.otherFundType}
          onOtherFundTypeChange={value => setFormField('otherFundType', value)}
          incomeMeasurementType={form.incomeMeasurementType}
          onIncomeMeasurementTypeChange={value => setFormField('incomeMeasurementType', value)}
          incomeMeasurementPercentage={form.incomeMeasurementPercentage}
          onIncomeMeasurementPercentageChange={value => setFormField('incomeMeasurementPercentage', value)}
          pledgeAmount={form.pledgeAmount}
          onPledgeAmountChange={value =>setFormField('pledgeAmount', value)}
          submissionType={form.submissionType}
          onSubmissionTypeChange={value => setFormField('submissionType', value)}
          additionalInformation={form.additionalInformation}
          onAdditionalInformationChange={value => setFormField('additionalInformation', value)}
          isSubmitting={isSubmitting}
        />
      );
    default:
      return <></>;
  }
};

export default FundTypeRenderer;